import React, {useRef, useState} from 'react'
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap"
import {useSelector} from "react-redux";
import * as Yup from "yup";
import {useForm} from "react-hook-form";

// components
import {GenericButton} from "../../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import Separator from "../../../../components/Separator";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import Switch from "react-bootstrap-switch";
import IconLangs from "../../icon/_langs";

// labels
import {FORM, INTERNATIONAL, LB_CODE, LB_DESCRIPTION, LB_IS_ACTIVE, LB_IS_MAIN, LB_NAME, REQUIRED} from "../../../../components/i18n/i18n";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../../components/i18n/toolTips";
import {PH_CODE, PH_DESCRIPTION, PH_NAME} from "../../../../components/i18n/placeHolders";

// utils
import {getStateByPath} from "../../../../redux/selectors";

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// services
import {iconService} from "../../../../jwt/_services/landings/iconService";
import {widgetIconService} from "../../../../jwt/_services/landings/widgetIconService";


const IconsForm = (props) => {
    const pageState = useSelector(state => getStateByPath(state, props.path));
    const { domainObject:widget, app } = pageState?.data || {};

    const path = `${props.path}/icons`;
    const componentState = useSelector(state => getStateByPath(state, path));

    const { editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app

    const translatableLangs = domainObject?.translatedLangs || []

    const [status, setStatus] = useState(!!domainObject?.status);
    const [isMain, setIsMain] = useState(!!domainObject?.isMain);
    const [langs, setlangs] = useState(domainObject?.langs || []);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);


    const validationSchema = Yup.object().shape({
        name: Yup.string().required( REQUIRED ),
        code: Yup.string().required( REQUIRED ),
    });

    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            name: domainObject?.name,
            code: domainObject?.code,
            description: domainObject?.description,
        }
    });

    const onSubmit = async (data, _) => {
        let labelRequest = {
            fbDataBase,
            item : {
                ...data,
                status: !!status,
                isMain: !!isMain
            }
        };

        if(editMode){
            labelRequest.item.id = domainObject?.id
            await iconService.updateItem(domainObject?.id, labelRequest) // actualizar la amenidad
            return
        }

        const iconResponse = await iconService.saveItem(labelRequest) // guardar la amenidad

        const requestData = {
            fbDataBase,
            item: {
                widget: { id: widget?.id },
                icon: { id: iconResponse?.id }
            }
        }

        genericIndexedActions.save(path, widgetIconService, requestData, closeForm) // vincular la amenidad con el tipo de habitación

    };

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }


    const closeForm = () => {
        reset();
        props.toggle()
    }


    return <Modal
        isOpen={props.isOpen}
        toggle={props.toggle}
        keyboard={false}
        modalClassName="menu-modal-form"
    >
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={'card-modal'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-edit mr-2"/>{FORM}
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <>
                                <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{LB_CODE}</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder={PH_CODE}
                                    innerRef={register}
                                />
                                {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>{LB_NAME}</Label>
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder={PH_NAME}
                                    innerRef={register}
                                />
                                { errors.name && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.name?.message}</div>}
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{LB_DESCRIPTION}</Label>
                                <Input
                                    type="textarea"
                                    name="description"
                                    placeholder={PH_DESCRIPTION}
                                    innerRef={register}
                                />
                                { errors.description && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.description?.message}</div>}
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="2">
                            <FormGroup>
                                <Label>{LB_IS_ACTIVE}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={ () => setStatus(!status) }
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2}>
                            <FormGroup>
                                <Label>{LB_IS_MAIN}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={isMain}
                                    onChange={ () => setIsMain(!isMain) }
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        { INTERNATIONAL }
                    </CardTitle>
                    <CardBody>
                        <IconLangs
                            langs={langs}
                            setLangs={setlangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>
                </CardBody>

                {
                    showModal && <LogHistoryModal
                        ref={modalRef}
                        item={domainObject}
                    />
                }
            </Card>
        </Form>
    </Modal>
}

export default IconsForm;